import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import initialSyncHistoryState from './sync-history.state';
import { ApiStatus } from 'common/enums';
import { SyncLog, SyncLogRequest } from '../models/sync-history.model';
import { PaginatedApiResponse } from 'common/models/api-service/api-response.model';

const syncHistorySlice = createSlice({
    name: 'syncHistory',
    initialState: initialSyncHistoryState,
    reducers: {
        fetchSyncLogs: (state, { payload }: PayloadAction<SyncLogRequest>) => {
            state.syncHistoryList.status = ApiStatus.LOADING;
        },
        fetchSyncLogsSuccess: (
            state,
            { payload }: PayloadAction<PaginatedApiResponse<SyncLog[]>>
        ) => {
            state.syncHistoryList.status = ApiStatus.SUCCESS;
            if (payload.pagination.currentPage === 1) {
                state.syncHistoryList.data = payload;
            } else {
                if (
                    state.syncHistoryList.data &&
                    state.syncHistoryList.data.data &&
                    state.syncHistoryList.data.data.length > 0 &&
                    payload.data &&
                    payload.data.length > 0
                ) {
                    let updatedData = [...state.syncHistoryList.data.data];
                    updatedData = updatedData.concat([...payload.data]);
                    state.syncHistoryList.data.data = updatedData;
                    state.syncHistoryList.data.pagination = payload.pagination;
                }
            }
        },
        fetchSyncLogsFailed: (state, { payload }: PayloadAction<any>) => {
            state.syncHistoryList.status = ApiStatus.ERROR;
        }
    }
});

export default syncHistorySlice.reducer;
export const syncHistoryActions = syncHistorySlice.actions;
